import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import AppLayout from "@/layouts/AppLayout";
import Dashboard from "@/pages/Dashboard";
import ClientiList from "@/pages/ClientiList";
import ClienteDetail from "@/pages/ClienteDetail";
import Richiami from "@/pages/Richiami";
import Calendario from "@/pages/Calendario";
import RicercaNote from "@/pages/RicercaNote";
import Backup from "@/pages/Backup";
import Accessi from "@/pages/Accessi";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/app/ProtectedRoute";

/**
 * AppRouter checks the URL hash SYNCHRONOUSLY (during render, not in useEffect)
 * to detect an Emergent OAuth callback. This prevents a race condition where
 * AuthProvider's /auth/me runs before the session is exchanged.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clienti" element={<ClientiList />} />
        <Route path="/clienti/:id" element={<ClienteDetail />} />
        <Route path="/richiami" element={<Richiami />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/ricerca-note" element={<RicercaNote />} />
        <Route path="/backup" element={<Backup />} />
        <Route path="/accessi" element={<Accessi />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}

export default App;
